import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

export const LEGAL_URLS = {
  terms: 'https://www.themenucompany.mx/terminos-y-condiciones',
  privacy: 'https://www.themenucompany.mx/aviso-de-privacidad',
};
